import { apiClient } from "services/api-client";

/**
 * Vendor Assessment API Service
 * Manages vendor records, risk classification, and assessment requests
 */

// ========== VENDOR CRUD OPERATIONS ==========

/**
 * Get all vendors for a company with optional pagination
 */
export const getVendors = async (tenant, page, perPage, filters = {}) => {
  let query = `/vendor/vendors?companyKey=${tenant}`;

  if (page && perPage) {
    query += `&page=${page}&perPage=${perPage}`;
  }

  // Add filters (tier, active status, search)
  if (filters.tier) {
    query += `&tier=${filters.tier}`;
  }
  if (filters.active !== undefined) {
    query += `&active=${filters.active}`;
  }
  if (filters.search) {
    query += `&search=${encodeURIComponent(filters.search)}`;
  }

  return await apiClient.get(query);
};

/**
 * Get a single vendor by ID
 */
export const getVendorById = async (id) => {
  return await apiClient.get(`/vendor/vendors/${id}`);
};

/**
 * Create a new vendor
 */
export const createVendor = async (vendor) => {
  return await apiClient.post('/vendor/vendors', vendor);
};

/**
 * Update an existing vendor
 */
export const updateVendor = async (id, vendor) => {
  return await apiClient.put(`/vendor/vendors/${id}`, vendor);
};

/**
 * Delete a vendor (soft delete)
 */
export const deleteVendor = async (id) => {
  return await apiClient.delete(`/vendor/vendors/${id}`);
};

// ========== VENDOR ASSESSMENT OPERATIONS ==========

/**
 * Get assessment history for a vendor
 */
export const getVendorAssessments = async (vendorId) => {
  return await apiClient.get(`/vendor/assessment/vendor/${vendorId}/history`);
};

/**
 * Get vendor summary statistics
 */
export const getVendorStats = async (tenant) => {
  return await apiClient.get(`/vendor/vendors/stats?companyKey=${tenant}`);
};

// ========== RECERTIFICATION SETTINGS ==========

/**
 * Get tier-level recertification period defaults for the company
 */
export const getRecertificationSettings = async (tenant) => {
  return await apiClient.get(`/vendor/settings/recertification?companyKey=${tenant}`);
};

/**
 * Update tier-level recertification period defaults for the company
 * @param {Object} settings - { tier1?: number, tier2?: number, tier3?: number } (months)
 */
export const updateRecertificationSettings = async (settings) => {
  return await apiClient.put('/vendor/settings/recertification', settings);
};
